import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { isBrowser } from 'Helpers/Browser';

import Photo from './components/Photo';
import CheckoutTitle from './components/CheckoutTitle';
import CheckoutLicense from './components/CheckoutLicense';
import CheckoutPricing from './components/CheckoutPricing';
import CheckoutDescription from './components/CheckoutDescription';

export default class SinglePhotoPhoto extends React.Component {
    static propTypes = {
        user: PropTypes.shape({
            accessToken: PropTypes.string
        }).isRequired,
        galleryData: PropTypes.shape({
            isEnabled: PropTypes.bool.isRequired,
            nextPhotoId: PropTypes.string,
            prevPhotoId: PropTypes.string
        }).isRequired,
        onClose: PropTypes.func.isRequired,
        onAddToCart: PropTypes.func.isRequired,
        onAddToLightbox: PropTypes.func.isRequired,
        onRemoveFromLightbox: PropTypes.func.isRequired,
        onPrevPhoto: PropTypes.func,
        onNextPhoto: PropTypes.func,
        creditsCount: PropTypes.number,
        photoData: PropTypes.shape({
            id: PropTypes.string.isRequired,
            selectedCaption: PropTypes.string,
            description: PropTypes.string.isRequired,
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired,
            license: PropTypes.string.isRequired,
            price: PropTypes.number.isRequired,
            imageUrl: PropTypes.string,
            resolutions: PropTypes.object,
            slug: PropTypes.string,
            user: PropTypes.shape({
                username: PropTypes.string.isRequired
            }),
            purchasable: PropTypes.bool,
            averageRating: PropTypes.number,
            ratingsCount: PropTypes.number,
            downloadUrl: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.object
            ]),
            isInCart: PropTypes.bool,
            isInLightbox: PropTypes.bool,
            mission: PropTypes.object
        }).isRequired,
        address: PropTypes.string,
        isAdmin: PropTypes.bool,
        currentBrandId: PropTypes.string,
    };
    static defaultProps = {
        isInCart: false,
        isInLightbox: false,
        isAdmin: false
    }

    state = {
        containerWidth: 0
    };

    componentDidMount = () => {
        if (isBrowser()) {
            this.setState({
                ...this.state,
                containerWidth: this.container.clientWidth
            });
            window.addEventListener('resize', this.handleResize);
        }

        if (this.props.galleryData && this.props.galleryData.isEnabled) {
            document.addEventListener("keydown", this.onKeyPress);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize, false);
        document.removeEventListener("keydown", this.onKeyPress);
    }

    handleResize = () => {
        this.setState({
            ...this.state,
            containerWidth: this.container.clientWidth
        });
    }

    onKeyPress = event => {
        switch (event.keyCode) {
            case 37:
                if (this.props.galleryData && this.props.galleryData.isEnabled) {
                    this.props.onPrevPhoto();
                }
                break;
            case 39:
                if (this.props.galleryData && this.props.galleryData.isEnabled) {
                    this.props.onNextPhoto();
                }
                break;
        }
    }

    render() {
        const { accessToken } = this.props.user;
        const { galleryData, creditsCount, currentBrandId, photoData } = this.props;
        const { id, purchasable, mission } = photoData;

        return (
            <div className="component-single-photo-photo" ref={node => this.container = node}>
                <div className="row" itemScope itemType="http://schema.org/Product">
                    <div className="col pull-left col-photo">
                        <Photo
                            photo={photoData}
                            onPrevPhoto={this.props.onPrevPhoto}
                            onNextPhoto={this.props.onNextPhoto}
                            onClose={this.props.onClose}
                            galleryData={galleryData}
                        />
                    </div>
                    <div className="col pull-right col-checkout">
                        <div className="content">
                            <div className="row row-title">
                                <CheckoutTitle photo={photoData} />
                            </div>
                            <div className="row row-license">
                                <CheckoutLicense photo={photoData} />
                            </div>
                            {(accessToken && purchasable) || (!mission || mission && mission.partnership && mission.partnership !== 'enterprise') ?
                                <div className="row row-pricing">
                                    <CheckoutPricing
                                        photo={photoData}
                                        onAddToCart={this.props.onAddToCart}
                                        onAddToLightbox={this.props.onAddToLightbox}
                                        onRemoveFromLightbox={this.props.onRemoveFromLightbox}
                                        creditsCount={creditsCount}
                                        isBrand={currentBrandId}
                                    />
                                </div>
                                : null}
                            <div className="row row-description">
                                <CheckoutDescription photo={photoData} />
                            </div>
                            {this.props.isAdmin ?
                                <Link className="curate-link" href={`${process.env.ADMIN_URL}/curated_photos/new?photo_id=${id}`} target="_blank">
                                    Curate
                                </Link>
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/single-photo/Photo/index.js